import { render, staticRenderFns } from "./consulta-especial.vue?vue&type=template&id=c5b74304&"
import script from "./consulta-especial.vue?vue&type=script&lang=js&"
export * from "./consulta-especial.vue?vue&type=script&lang=js&"
import style0 from "./consulta-especial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports